import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import LoadingDots from 'src/assets/loading_dots.svg';
import AnimatedLogo from 'src/ConnectedComponents/utils/AnimatedLogo';
import { FlexBox, Box } from 'src/lib/StyledComponents';

const Loader = ({ useLogo }) => (
	<FlexBox justifyContent="center">
		{useLogo ? (
			<AnimatedLogo style={{ height: '160px' }} fadein={true} />
		) : (
			<LoadingDots style={{ height: '50px' }} />
		)}
	</FlexBox>
);

const InfiniteScrollList = props => (
	<Box height={props.height ? `${props.height}` : '600px'} overflow="auto" paddingBottom="10px">
		<InfiniteScroll
			initialLoad={props.initialLoad}
			pageStart={0}
			loadMore={props.loadFunction}
			loader={props.showLoader && <Loader key={'loader'} useLogo={props.useLogo} />}
			hasMore={props.hasMore}
			threshold={250}
			useWindow={false}
		>
			{props.children}
			{props.data.map((datum, index) => (
				<Box key={index}>{props.renderItem(datum, index)}</Box>
			))}
		</InfiniteScroll>
	</Box>
);

export default InfiniteScrollList;



// WEBPACK FOOTER //
// ./src/components/InfiniteScroll/index.js